
import { NoEcommerce } from '@/scripts/libs/no-ecommerce'
import { mapGetters } from 'vuex'

export default {
  name: 'rb-footer',
  data() {
    return {
      isNoEcommerce: false,
    }
  },
  computed: {
    ...mapGetters(['noEcommerceCounter']),
  },
  watch: {
    noEcommerceCounter() {
      this.isNoEcommerce = NoEcommerce.isStoreNoEcommerce()
    },
  },
  mounted() {
    this.isNoEcommerce = NoEcommerce.isStoreNoEcommerce()
  },
}
